import { gql } from '@apollo/client';

export const REGIONS_QUERY = gql`
  {
    regions {
      id
      name
      displayName
      coord
      zoom
    }
  }
`;

export const COUNTRIES_QUERY = gql`
  query countryStatistics($filters: JSON) {
    countryStatistics(filters: $filters) {
      id
      displayName
      name
      isoCode
    }
  }
`;
